import { z } from 'zod';
import { MILESTONE_STATES } from './milestones.js';
/** The weekly status report (WR-1 to WR-3) for one week. */
export const reportsResponseSchema = z.object({
    /** The week's Monday, and "week of 21 September". */
    week: z.string(),
    weekLabel: z.string(),
    /** Stepping: an earlier week, and a later one up to the latest. */
    previousWeek: z.string().nullable(),
    nextWeek: z.string().nullable(),
    /** "Sun 27 Sep, 9:00 PM"; null when Talos didn't write this week's report (WR-2). */
    writtenLabel: z.string().nullable(),
    team: z.string().nullable(),
    projects: z.array(z.object({
        slug: z.string(),
        name: z.string(),
        /** Talos's narrative; null when it wrote none for this project. */
        narrative: z.object({ moved: z.string(), risk: z.string(), next: z.string() }).nullable(),
        /** Pulse's own figures for the week. */
        figures: z.object({ built: z.number(), merged: z.number(), toProduction: z.number(), accepted: z.number().nullable() }),
        /** Its open milestones, each with its state now (MS-4). */
        milestones: z.array(z.object({ title: z.string(), dateLabel: z.string(), state: z.enum(MILESTONE_STATES) })),
        /** The week's followed meetings that talked about it (MT-4), linked to its Meetings tab. */
        meetings: z.array(z.object({ title: z.string(), dateLabel: z.string() })),
    })),
});
//# sourceMappingURL=reports.js.map